import type { ModalId } from "@@/modals/context/modal-id";
import { Modal } from "@@/modals/modal";
import { ModalHeader } from "@@/modals/modal-header";
import { useModal } from "@@/modals/use-modal";
import { ButtonPrimary } from "@@/shared/buttons_v2/button-primary";
import { FlexColumn } from "@@/shared/flex-containers";
import { TextBox } from "@@/shared/text";
import { SnakeGame } from "@@/users/modal/snake/snake";

const SnakeButton = () => {
    const [{ show }, modalId] = useModal("test_modal__");
    return (
        <>
            <ButtonPrimary onClick={show}>
                <TextBox text={"Snake"} />
            </ButtonPrimary>
            <SnakeModal modalId={modalId} />
        </>
    );
};

type Props = {
    modalId: ModalId;
};
const SnakeModal = (props: Props) => {
    return (
        <Modal
            modalId={props.modalId}
            header={
                <ModalHeader
                    modalId={props.modalId}
                    bottomBorder
                    title={"Snake"}
                />
            }>
            <FlexColumn fillParentWidth padding={{ all: 20 }}>
                <SnakeGame />
            </FlexColumn>
        </Modal>
    );
};

export { SnakeButton };
